import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  canAccess,
  getCurrentUserRole,
  normalizeAppRole,
  type AccessAction,
} from "../../constants/accessRights";

interface RequireAccessProps {
  rowId?: string;
  anyOf?: string[];
  action?: AccessAction;
  fallbackPath?: string;
  children: ReactNode;
}

export default function RequireAccess({
  rowId,
  anyOf,
  action = "read",
  fallbackPath = "/workspace",
  children,
}: RequireAccessProps) {
  const location = useLocation();
  const role = normalizeAppRole(getCurrentUserRole());
  const allowed = anyOf?.length
    ? anyOf.some((id) => canAccess(id, role, action))
    : rowId
      ? canAccess(rowId, role, action)
      : false;

  if (!allowed) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
